module.exports = __webpack_public_path__ + "static/media/user-dropdown-exit.fbc17dd8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/user-dropdown-exit.svg
// module id = 1481
// module chunks = 0